// src/pages/Datenschutzerklaerung.tsx
import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { usePublicLang } from "../config/i18n/public";
import { PRIVACY_POLICY_TEXTS } from "../config/i18n/privacyPolicyTexts";

function isHeading(line) {
  return /^(\d+\.?|\d+\.\d+)\s+/.test(line) || /^(Inhaltsverzeichnis|Table of Contents)$/.test(line);
}

function getSectionNumber(line) {
  return line.match(/^(\d+(?:\.\d+)*)(?:\.)?\s+/)?.[1] || null;
}

function getSectionId(sectionNumber) {
  return `privacy-section-${sectionNumber.replaceAll(".", "-")}`;
}

export default function Datenschutzerklaerung() {
  const { copy, lang } = usePublicLang();
  const c = copy.legal.datenschutz;
  const lastUpdated = lang === "en" ? "April 22, 2026" : "22.04.2026";
  const policyText = PRIVACY_POLICY_TEXTS[lang] || PRIVACY_POLICY_TEXTS.de;
  const lines = policyText.split("\n");
  const seenSectionNumbers = new Set();

  return (
    <div>
     <Header />
    <div className="max-w-3xl mx-auto p-6 text-gray-800">
      <header className="mb-6">
        <h1 className="text-3xl font-bold">{c.title}</h1>
        <p className="text-sm text-gray-600">
          {c.updated_label} {lastUpdated}
        </p>
      </header>

      <article className="space-y-2 text-sm leading-7 md:text-base">
        {lines.map((line, index) => {
          if (!line.trim()) {
            return <div key={index} className="h-3" />;
          }

          if (index === 0) {
            return (
              <h2 key={index} className="mb-4 text-2xl font-semibold text-gray-900">
                {line}
              </h2>
            );
          }

          const sectionNumber = getSectionNumber(line);
          const isTableOfContentsLink = sectionNumber && !seenSectionNumbers.has(sectionNumber);
          if (sectionNumber) {
            seenSectionNumbers.add(sectionNumber);
          }

          if (isTableOfContentsLink) {
            return (
              <p key={index}>
                <a href={`#${getSectionId(sectionNumber)}`} className="text-blue-700 hover:underline">
                  {line}
                </a>
              </p>
            );
          }

          if (isHeading(line)) {
            return (
              <h3
                key={index}
                id={sectionNumber ? getSectionId(sectionNumber) : undefined}
                className="scroll-mt-24 pt-5 text-lg font-semibold text-gray-900"
              >
                {line}
              </h3>
            );
          }

          return <p key={index}>{line}</p>;
        })}
      </article>
    </div>
    <Footer/>
    </div>
  );
}
